import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FlexContainer } from "../../../constants/assets/containers";
import FilterSearchBar from "../FilterSearchBar";
import PartnersListTable from "../PartnersListTable";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DeliveryDriversActions from "../../../store/actions/DeliveryDrivers";
import ListPagination from "../../Common/ListPagination";
import { isMobile } from "../../../utils";

const PartnersList = ({
  list,
  applyFilters,
  clearFilters,
  getDriversList,
  nextPage,
  prevPage,
  allFilters,
  driverListFilters,
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  //handle pagination
  const handleNavClick = (action) => {
    let filters = { ...allFilters };
    if (action === "prev") {
      filters["page"] = currentPage - 1;
      setCurrentPage(currentPage - 1);
      getDriversList(filters);
    } else {
      filters["page"] = currentPage + 1;
      setCurrentPage(currentPage + 1);
      getDriversList(filters);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(allFilters)]);

  useEffect(() => {
    if (driverListFilters.page !== currentPage) {
      setCurrentPage(driverListFilters.page);
    }
  }, []);

  return (
    <PartnerListContainer align="flex-start">
      <LeftSection>
        <FilterSearchBar
          applyFilters={applyFilters}
          clearFilters={clearFilters}
        />
      </LeftSection>
      <RightSection>
        <PartnersListTable list={list} />
        <ListPagination
          nextPage={nextPage}
          prevPage={prevPage}
          handleNavClick={handleNavClick}
        />
      </RightSection>
    </PartnerListContainer>
  );
};

const PartnerListContainer = styled(FlexContainer)`
  flex-direction: ${isMobile() ? "column" : "row"};
  align-items: ${isMobile() ? "inherit" : "flex-start"};
`;

const LeftSection = styled.div`
  flex: 0 1 30%;
  margin-bottom: ${isMobile() ? "20px" : "unset"};
`;

const RightSection = styled.div`
  flex: 0 1 70%;
  height: calc(100vh - 200px);
  width: 100%;
`;

function mapStateToProps(state) {
  const { DeliveryDrivers } = state;
  return {
    nextPage: DeliveryDrivers.nextPage,
    prevPage: DeliveryDrivers.prevPage,
    driverListFilters: DeliveryDrivers.driverListFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriversList: bindActionCreators(
      DeliveryDriversActions.getDriversList,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnersList);
